<template>
  <v-app>
    <v-navigation-drawer
      width="260"
      v-model="drawer"
      fixed
      left
      clipped
      app
      class="content"
    >
      <v-list>
        <h2
          class="title text-xs-left pa-4 grey--text text--darken-1 mb-2"
          style="border-bottom: 1px solid #efefef"
        >
          Área administrativa
        </h2>
        <v-list-tile
          v-for="item in items"
          v-bind:key="item.name"
          :to="item.path"
          :class="[defineMasterUser(item.name) ? '' : 'hideLink']"
          v-show="item.noShow && item.noShow === 'hide' ? false : true"
        >
          <v-list-tile-action v-if="defineMasterUser(item.name)" class="pl-2">
            <v-icon :class="[item.icon === 'build' ? 'smaller' : '']">{{
              item.icon
            }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content v-if="defineMasterUser(item.name)">
            <v-list-tile-title>{{ item.text }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar color="blue-grey lighten-5" dark fixed app clipped-left>
      <v-toolbar-side-icon
        class="mr-3"
        color="grey--text text--darken-1"
        @click.stop="drawer = !drawer"
        v-if="$vuetify.breakpoint.mdAndDown"
      ></v-toolbar-side-icon>
      <v-img
        v-if="$store.state.config.logo.src != './img/ajax-loader.gif'"
        :src="$store.state.config.logo.src"
        class="white--text"
        max-height="55px"
        max-width="150px"
        position="left center"
        contain
        :alt="$store.state.config.logo.title"
      />
      <v-spacer></v-spacer>

      <UserInfo />
    </v-toolbar>

    <v-content class="content">
      <v-container fluid fill-height>
        <v-layout justify-center align-top>
          <v-flex>
            <router-view></router-view>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <v-footer color="primary" class="white--text px-4" app>
      <span></span>
      <v-spacer></v-spacer>
      <span>&copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
  </v-app>
</template>

<script>
import UserInfo from '../components/common/UserInfo.vue'

export default {
  name: 'Layout',

  components: {
    UserInfo
  },

  props: {
    source: String
  },

  data () {
    return {
      prevRoute: '',
      items: [],
      masterType: '',
      drawer: true,
      changePwdDlg: false
    }
  },

  beforeMount () {
    this.$store
      .dispatch('permissions/getPermissions')
      .then((objPermissions) => {
        if (objPermissions.permissions.Adm) {
          this.items = this.$router.options.routes[1].children
          // objPermissions.map()
          this.items = this.items.map((i) => {          
            if (objPermissions.permissions[i.name]) {
              let noShow = 'hide'

              for (var allPerms in objPermissions.permissions[i.name]) {
                // console.log("obj." + prop + " = " + obj[prop]);
                if (objPermissions.permissions[i.name][allPerms]) {
                  noShow = 'show'
                }
              }
              i.noShow = noShow
            }
            return i
          })

          return
        }

        this.items = this.$router.options.routes[1].children.filter((lnk) => {
          if (lnk.name === 'reports') {
            return lnk
          }
          if (lnk.name === 'clients') {
            return lnk
          }
          let hasTrueItem = false
          let forkey = objPermissions.permissions[lnk.name]
          // console.log('forkety')
          for (var key in forkey) {
            if (forkey[key] === true) {
              hasTrueItem = true
            }
          }

          // console.log("menu", lnk);
          if (hasTrueItem) {
            return lnk
          }
        })
      })

    const user = JSON.parse(localStorage.userData)
    let typeMaster = user.type === 'master'
    this.masterType = typeMaster
  },

  mounted () {
    this.verifyUserType()
    this.getUser().then((user) => {
      this.getTheme(user)
    })
  },

  methods: {
    
    defineModulesStatus () {
      let modulesSelected = this.$store.state.modulesAvaliable
      Object.keys(modulesSelected).forEach((key) => {})
    },

    defineMasterUser (name) {
      let userType = false
      if (this.masterType) {
        if (name === 'clients') {
          userType = true
        }
      } else {
        if (name !== 'clients') {
          userType = true
        }
      }

      if (!this.masterType && (name === 'users' ||name === 'condominiums' || name === 'documents' || name === 'contracts' || name === 'reports' || name === 'financial' || name === 'profile' || name === 'thirds' || name === 'provision' || name === 'dashboard' || name === 'checklists' || name === 'standards' || name === 'datasheet')) {
        switch (name) {
          case 'users':
            if (this.$store.state.modulesAvaliable.users === 0) {
              userType = false
            }
            break
          case 'condominiums':
            if (this.$store.state.modulesAvaliable.condominiums === 0) {
              userType = false
            }
            break
          case 'documents':
            if (this.$store.state.modulesAvaliable.documents === 0) {
              userType = false
            }
            break
          case 'contracts':
            if (this.$store.state.modulesAvaliable.contracts === 0) {
              userType = false
            }
            break
          case 'reports':
            if (this.$store.state.modulesAvaliable.reports === 0) {
              userType = false
            }
            break
          case 'profile':
            if (this.$store.state.modulesAvaliable.profile === 0) {
              userType = false
            }
            break
          case 'thirds':
            if (this.$store.state.modulesAvaliable.thirds === 0) {
              userType = false
            }
            break
          case 'provision':
            if (this.$store.state.modulesAvaliable.provision === 0) {
              userType = false
            }
            break
          case 'dashboard':
            if (this.$store.state.modulesAvaliable.dashboard === 0) {
              userType = false
            }
            break
          case 'checklists':
            if (this.$store.state.modulesAvaliable.checklists === 0) {
              userType = false
            }
            break
          case 'financial':
            if (this.$store.state.modulesAvaliable.financial === 0) {
              userType = false
            }
            break
          case 'standards':
            if (this.$store.state.modulesAvaliable.standards === 0) {
              userType = false
            }
            break
          case 'datasheet':
            if (this.$store.state.modulesAvaliable.datasheet === 0) {
              userType = false
            }
            break

          default:
            break
        }
      }
      return userType
    },

    verifyUserType () {
      const user = JSON.parse(localStorage.userData)

      if (user.type === 'master' && this.$router.history.current.path === '/') {
        this.$router.push('/clients')
      }

      if (user.type === 'client' && this.$router.history.current.path === '/') {
        this.$router.push('/users')
      }

      if (user.type === 'user' && this.$router.history.current.path === '/') {
        let obj = {
          message: `Selecione uma das opções no menu lateral para continuar.`,
          title: `Olá ${user.name}!`,
          callback: (_) => {},
          type: 'success',
          btConfirm: { name: 'Sim', show: false },
          btCancel: { name: 'Continuar', show: true }
        }

        this.$store.commit('confirmMessage/showConfirmMessage', obj)
      }
    },

    async getUser () {
      const user = await JSON.parse(localStorage.getItem('userData'))

      this.userName = user.name
      this.accountable = user.accountable || user.email

      return user
    },

    getTheme (user) {
      if (!user || !user.user_id) {
        return
      }

      let modulesId = user.user_id === 1 ? user.id : user.user_id

      let obj = {
        url: '/api/clienttheme_modules/' + modulesId,
        query: '',
        method: 'get',
        noLoader: true
      }

      this.$store.dispatch('request/doRequest', obj).then((response) => {
        this.$store.commit(
          'updateModulesAvaliable',
          response.data.modules_available_users
        )

        let obj = {
          bg: response.data.clienttheme_users.background
            ? response.data.clienttheme_users.background
            : './img/insight_img_bg_1.jpg',
          logo: response.data.clienttheme_users.logo
            ? response.data.clienttheme_users.logo
            : './img/logo.png'
        }

        this.$vuetify.theme.primary = response.data.clienttheme_users.color
          ? response.data.clienttheme_users.color
          : '#002857'

        this.$store.commit('setNewThemeSystem', obj)
      })
    }
  }
}
</script>

<style>
.home {
  /* align-items: top; */
  background-color: rgba(255, 255, 255, 0.1);
  display: flex;
  height: 100vh;
}
.content {
  background-color: rgba(255, 255, 255, 0.75) !important;
}
.hideLink {
  display: none !important;
}

.smaller {
  font-size: 21px !important;
}
.verySmall {
  width: 20px !important;
  height: 20px !important;
}
</style>
